import React, { Context, ReactNode, useContext } from 'react';
import { FilterIcon } from '../assets/icons';
import { SortDirection } from '../config/constants';
import { ActiveSortType, SpoolsType, SortKey } from '../context/spools/spoolsType';

type Props = {
    dataKey: SortKey;
    variant?: string;
    withSort?: boolean;
    children: ReactNode;
    context: Context<SpoolsType>;
};

const TableHeader: React.FC<Props> = ({
    dataKey,
    children,
    variant = 'default',
    withSort = true,
    context,
}) => {
    const { handleSortClick, activeSort, showSelect, toggleFilter } = useContext(context);

    const sort = (
        dataKey: SortKey,
        activeSort: ActiveSortType,
        showSelect: { [key: string]: boolean },
        withSort: boolean
    ) => {
        if ((showSelect && showSelect[dataKey]) || !withSort) return;

        handleSortClick(dataKey, activeSort);
    };

    const toggle = (e: React.MouseEvent<SVGSVGElement>) => {
        e.stopPropagation();
        toggleFilter(dataKey);
    };

    return (
        <div
            className={`table-header ${variant === 'filter' ? 'filter' : ''} ${
                showSelect?.[dataKey] ? 'filtering' : ''
            }`}
            onClick={() => sort(dataKey, activeSort, showSelect, withSort)}
        >
            {children}
            {variant === 'filter' && (
                <div className='filter'>
                    <FilterIcon onClick={toggle} />
                </div>
            )}

            {withSort ? (
                <div className='arrow-container'>
                    <div
                        className={`arrow-up ${
                            activeSort?.key === dataKey &&
                            activeSort?.direction === SortDirection.DESC
                                ? 'active'
                                : ''
                        }`}
                    />
                    <div
                        className={`arrow-down ${
                            activeSort?.key === dataKey &&
                            activeSort?.direction === SortDirection.ASC
                                ? 'active'
                                : ''
                        }`}
                    />
                </div>
            ) : null}
        </div>
    );
};

export default TableHeader;
